import React from 'react';
import s from './inputStyle.module.scss';

function InputStyle (props) {
	const {
		onChangeAction, isThisCurrentStep, actionOnFocus, inputId, value, inputStyle
	} = props;

	return (
		<input data-prevent-from-blur className={s[inputStyle]} id={inputId} type="number" value={value} pattern="\d*" onFocus={actionOnFocus} onChange={onChangeAction} tabIndex={!isThisCurrentStep ? -1 : ''} />
	);
}

export default InputStyle;
